<!-- components/PopupInquiryView.svelte -->
<script>
  import { onMount, onDestroy } from 'svelte';
  import { modifyInquiry } from '@lib/api/inquiry';
  import { formatDateToKorean } from '@lib/util/dateUtils';

  export let mode = 'create';       // 'create' = 등록, 'modify' = 수정
  export let onClose = () => {};    // 팝업 닫기 콜백
  export let onSave = () => {};     // 저장 완료 콜백
  export let initialData = {        // 수정 시 전달받는 초기 데이터
    status: '',
    title: '',
    content: '',
    created_name:'',
    created_id:'',
    created_at:'',
    answer:'',
  };    

  let warningMessage = '';          // 공통 경고 메시지

  let formData = {
    inquiry_id: '',
    answer:'',
  };

  $: actionLabel = mode === 'create' ? '저장하기' : '수정하기';
  $: actionTitle = mode === 'create' ? '저장' : '수정';
  // 저장 처리 함수
  async function handleSubmit() {
    // 문의취소 상태인 경우, 저장 차단
    if (initialData.status === '문의취소') {
        warningMessage = '취소된 문의에는 답변을 등록할 수 없습니다.';
        return;
    }
    // 유효성 검사 시작
    if (!formData.answer || formData.answer.trim() === '') {
        warningMessage = '답변 내용을 입력해주세요.';
        return;
    }

    // 유효성 통과 시
    warningMessage = ''; // 경고 초기화

    formData.answer = initialData.answer;
    formData.status = "답변완료"

    try {
      if (mode === 'create') {
        const result = await modifyInquiry(formData);
        console.log('최초 수정 성공:', result);
      } else if (mode === 'modify') {
        const result = await modifyInquiry(formData);
        console.log('수정 성공:', result);
      }

      onSave();
    }
     catch (e) {
      console.error('저장 실패:', e);
      warningMessage = e.message || '저장 중 오류가 발생했습니다.';
    }
  }

  onMount(() => {
    
    formData = {
          inquiry_id: initialData._id || '',
          answer: initialData.answer || '',
    };

  });

  onDestroy(() => {

  });
</script>
<div class="popup-wrap" id="popup-inquiry-view">
  <div class="popup-overlay" role="presentation" aria-label="팝업 닫기" on:click={onClose}></div>
    <section class="popup-container">
        <div class="popup-container__inner d-flex h-100" style="max-height:90%;max-width:90%;">
            <div class="d-flex flex-column w-100">
                <div class="popup-header">
                    <div class="d-flex align-center w-100">
                        <p class="font-20 font-weight-700 line-height-2">
                            문의 답변 {actionTitle}
                        </p>
                        <button type="button" class="btn-close ml-auto" aria-label="닫기" on:click={onClose}>
                          <i class="icon icon-close"></i>
                        </button>
                    </div>
                </div>
                <div class="popup-cont">
                    <div class="d-flex h-100" style="gap:3rem">
                        <div class="prompt-block">
                            <div class="d-flex flex-column h-100 bg-white box-border">
                                <div class="table-wrap h-100">
                                    <table class="table-basic table-basic-inquiryView">
                                        <caption></caption>
                                        <colgroup>
                                            <col style="width:15%">
                                            <col style="width:auto">
                                            <col style="width:15%">
                                            <col style="width:35%">
                                        </colgroup>
                                        <tbody>
                                        <tr>
                                            <th scope="row">문제유형</th>
                                            <td colspan="3">{initialData.status || ''}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">문의제목</th>
                                            <td colspan="3">{initialData.title || ''}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">프롬프트 내용</th>
                                            <td colspan="3" class="h-100 custom-textarea">
                                                <div class="prompt-cont">
                                                    { initialData.content || ''}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">등록자(User ID)</th>
                                            <td> {initialData.created_name || ''}({initialData.created_id || ''})</td>
                                            <th scope="row">등록일시</th>
                                            <td>{formatDateToKorean(initialData.created_at || '')}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="prompt-block">
                            <p class="font-16">문의 답변</p>
                            <div class="table-wrap flex-1 mt-5">
                                <table class="table-basic table-border table-basic-inquiryAnswer">
                                    <caption>문의 답변 테이블</caption>
                                    <colgroup>
                                        <col style="width:15%">
                                        <col style="width:auto">
                                        <col style="width:15%">
                                        <col style="width:35%">
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <td colspan="4">
                                            <div class="custom-textarea h-100">
                                                <form action="" class="h-100">
                                                    <fieldset class="h-100">
                                                        <legend></legend>
                                                        <textarea class="h-100" placeholder="지문 내용을 입력" title="지문 내용을 입력"  bind:value={initialData.answer} disabled={initialData.status === '문의취소'}
                                                        ></textarea>
                                                    </fieldset>
                                                </form>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            {#if warningMessage}
                            <p class="d-flex align-center mt-3 font-13 color-red">
                              <i class="icon icon-calmMark-red mr-1"></i>
                              {warningMessage}
                            </p>
                            {/if}
                        </div>
                    </div>
                </div>
                <div class="popup-footer">
                    <div class="btn-wrap justify-center" style="border-top:none;">
                        <button type="button" class="btn border-blue" on:click={onClose}>취소하기</button>
                        <button type="button" class="btn bg-blue ml-2" on:click={handleSubmit} >{actionLabel}</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>